import { useCallback, useContext } from 'react';
import { useFileDragDrop } from '@/components/FileDragDrop/hooks';
import { RateLimitingContext } from '@trinity/chat-components/containers/RateLimiting/Context.js';
import { WorkspaceObjectType } from '@/enums';
import type { IWorkspaceBrandItem, IWorkspaceFileItem, IWorkspaceFolderItem } from '@/types/workspace.table';
import { cx } from '@trinity/chat-components';
import { DnDUploadContainer } from './DnDUploadContainer';
import { Brand } from './Files.Table.Grid.Brand';
import { File } from './Files.Table.Grid.File';
import { Folder } from './Files.Table.Grid.Folder';
import type { IFilesTable } from './interfaces';
import styles from './style/Files.Table.Grid.module.css';

type FilesTableGridProps = {
  classes?: {
    root?: string;
    files?: string;
  };
  items: IFilesTable.Item[];
  canUpload: boolean;
  onUpload?: (files: File[]) => unknown;
};

export const FilesTableGrid = ({ classes = {}, ...props }: FilesTableGridProps) => {
  const renderItem = useCallback((data: IFilesTable.Item) => {
    switch (data.object.typeId) {
      case WorkspaceObjectType.Brand: {
        return <Brand key={data.object.id} item={data as IWorkspaceBrandItem} />;
      }
      case WorkspaceObjectType.File: {
        const item = data as IWorkspaceFileItem;
        return (
          <File key={data.object.id} item={item} />
        );
      }

      case WorkspaceObjectType.Folder:
        return <Folder key={data.object.id} item={data as IWorkspaceFolderItem} />;

      case WorkspaceObjectType.Workspace:
        return null;

      default:
        throw new Error(`Unreachable case: ${data.object.typeId}`);
    }
  }, []);

  return (
    <DnDUploadContainer
      canUpload={props.canUpload}
      onUpload={props.onUpload}>
      <div className={cx(styles.root, classes.root)}>
        <div className={cx(styles.files, classes.files)}>
          {props.items.map(renderItem)}
        </div>
      </div>
    </DnDUploadContainer>
  );
};